/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingService {
    /**
     * Set a state whether the step is loading or not, during loading the loading is shown.
     */
    public loadingButtonEmitter: Subject<any> = new Subject<any>();

    /**
     * Set a state whether the action dots is loading or not.
     */
    public loadingActionDotsEmitter: Subject<boolean> = new Subject<boolean>();

    constructor() {
    }
}
